import './ChatBubble.css';

const ChatBubble = ({ onClick }) => {
    return (
        <button
            className="chatwidget-bubble-btn"
            onClick={onClick}
        >
            <img
                src="/Image/logo-pippip.png"
                alt="Pippip Logo"
                className="chatwidget-pippip-logo"
                loading="lazy"
            />
            <span className="chatwidget-bubble-label">
                Tư vấn đặt xe
            </span>
        </button>
    );
};

export default ChatBubble;